package dev.bitspittle.droidconSf24.pages.sections.kobweb.basics

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun KobwebCli4Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/basics/KobwebCli4.md", mapOf("data-auto-animate-restart" to listOf()))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("kobweb-configuration") }) {
                org.jetbrains.compose.web.dom.Text("Kobweb Configuration")
            }
            dev.bitspittle.droidconSf24.components.widgets.Code("""# .kobweb/conf.yaml
site:
  title: "App"

server:
  port: 8080

  files:
    dev:
      contentRoot: "build/processedResources/js/main/public"
      script: "build/dist/js/developmentExecutable/app.js"
      api: "build/libs/app.jar"
    prod:
      script: "build/dist/js/productionExecutable/app.js"
      siteRoot: ".kobweb/site"
""", "yaml 0|6|0 <hide-vertical-scrollbar>")
        }
    }
}
